import { render, staticRenderFns } from "./AppListDelivery.vue?vue&type=template&id=a924dd30&"
import script from "./AppListDelivery.vue?vue&type=script&lang=ts&"
export * from "./AppListDelivery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports